import React from 'react';

import { Drawer } from '../../design/components';

interface IngredientDrawerProps {
  open: boolean;
  onClose: () => void;
  ingredients: string[];
}

/**
 * Bottom-sheet drawer displaying the recipe's ingredient list while
 * cooking. Large, readable typography because hands are sticky and
 * eyes are 60cm away from the screen on the worktop.
 */
const IngredientDrawer: React.FC<IngredientDrawerProps> = ({
  open,
  onClose,
  ingredients,
}) => (
  <Drawer open={open} onClose={onClose} position="bottom" title="Ingredients">
    {ingredients.length === 0 ? (
      <p
        style={{
          fontFamily: 'var(--sans)',
          color: 'var(--ink-mute)',
          margin: 0,
          fontSize: 16,
        }}
      >
        No ingredients listed.
      </p>
    ) : (
      <ul className="rr-cook-drawer-list">
        {ingredients.map((ing, i) => (
          <li key={i} className="rr-cook-drawer-item">
            <span className="rr-cook-drawer-index" aria-hidden="true">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className="rr-cook-drawer-text">{ing}</span>
          </li>
        ))}
      </ul>
    )}
  </Drawer>
);

export default IngredientDrawer;
